import dataService from 'services/dataService';
import { apiPatientStatusLogs } from 'services/dataService/resources';

const ITEMS_PER_PAGE = 10;

const patientStatusLogs = {
  state: {
    page: 1,
    pageStep: ITEMS_PER_PAGE,
    reversed: false,
    totalCount: 1,
    totalPages: 0,
    data: [],
  },
  reducers: {
    setPatientStatusLogs: (state, payload) => ({
      ...state,
      data: [...payload],
    }),
    setPage: (state, payload) => ({
      ...state,
      page: payload,
    }),
    setTotalCountAndTotalPages: (state, payload) => ({
      ...state,
      totalCount: payload.totalCount,
      totalPages: payload.totalPages,
    }),
    toggleReversed: (state) => ({
      ...state,
      reversed: !state.reversed,
    }),
  },
  effects: (dispatch) => ({
    async getPatientStatusLogs(patientGuid, state) {
      const { page, reversed } = state.patientStatusLogs;
      const { data } = await dataService.getList(
        apiPatientStatusLogs(patientGuid, page, reversed),
      );
      dispatch.patientStatusLogs.setPatientStatusLogs(data?.data || []);
      const totalCount = data?.count || 0;
      const totalPages = Math.ceil(totalCount / ITEMS_PER_PAGE);

      dispatch.patientStatusLogs.setTotalCountAndTotalPages({
        totalCount,
        totalPages,
      });
    },
    async setPagePatientStatusLogs({ pageOffset }, state) {
      const { page, totalPages } = state.patientStatusLogs;
      const newPage = page + pageOffset;
      dispatch.patientStatusLogs.setPage(
        newPage <= totalPages ? newPage : totalPages,
      );
    },
    async toggleOrder() {
      dispatch.patientStatusLogs.toggleReversed();
      dispatch.patientStatusLogs.setPage(1);
    },
  }),
};

export default patientStatusLogs;
